var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3A414C",
  d: "M2 14.75C2 16.025 2.975 17 4.25 17h10.5c1.275 0 2.25-.975 2.25-2.25v-6H2zM14.75 3.5h-1.5v-.75c0-.45-.3-.75-.75-.75s-.75.3-.75.75v.75h-4.5v-.75c0-.45-.3-.75-.75-.75s-.75.3-.75.75v.75h-1.5C2.975 3.5 2 4.475 2 5.75v1.5h15v-1.5c0-1.275-.975-2.25-2.25-2.25"
})));
export { SvgCalendarDark as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar-dark.b4ddf66a.svg";